import { useLocale } from 'shared-ui';

import { AppMessages } from 'i18n/messages';

import { PasswordValidationInfoProps } from './PasswordValidationInfo.types';
import * as Styled from './PasswordValidationInfo.styles';

const VALIDATION_CONDITIONS = [
  'profile.changePassword.validation.info.condition_1',
  'profile.changePassword.validation.info.condition_2',
  'profile.changePassword.validation.info.condition_3',
  'profile.changePassword.validation.info.condition_4',
  'profile.changePassword.validation.info.condition_5',
  'profile.changePassword.validation.info.condition_6',
  'profile.changePassword.validation.info.condition_7',
  'profile.changePassword.validation.info.condition_8',
  'profile.changePassword.validation.info.condition_9',
] as const;

export const PasswordValidationInfo = ({
  isVisible,
  isError,
  minimumPasswordLength = 8,
}: PasswordValidationInfoProps) => {
  const { formatMessage } = useLocale();

  return (
    <Styled.ValidationInfo $isVisible={isVisible} $isError={isError}>
      <p>
        {formatMessage({
          id: AppMessages['profile.changePassword.validation.info.title'],
        })}
      </p>
      <Styled.ValidationList>
        {VALIDATION_CONDITIONS.map((condition) => (
          <li key={condition}>
            {formatMessage(
              {
                id: AppMessages[condition],
              },
              { minimumPasswordLength },
            )}
          </li>
        ))}
      </Styled.ValidationList>
    </Styled.ValidationInfo>
  );
};
